import TeamMemberFile from './container';
// import reducer from './module';

export default TeamMemberFile;
